'use client'
import EditIcon from '@/app/icons/edit'
import UserContext from '@/context/user-context'
import useClientRender from '@/util/use-client-render'
import { useContext, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { clearBulkEdit, setBulkEditOpen, useBulkEditOpen } from './bulk-edit-state'

const OpenButton = () => {
    return (
        <div className="fixed right-5 bottom-5 hidden md:block">
            <div
                className="flex cursor-pointer items-center justify-center border-2 border-solid border-giphyGreen bg-giphyDarkestGrey  p-3"
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setBulkEditOpen(true)
                }}
            >
                <EditIcon className="size-4 fill-giphyWhite" />
            </div>
        </div>
    )
}

const BulkEditButton = () => {
    const isEnabled = useBulkEditOpen()
    const { user } = useContext(UserContext)
    const isClient = useClientRender()
    useEffect(() => {
        return () => clearBulkEdit()
    }, [])
    return isClient && user?.permissions?.bulk_edit
        ? createPortal(isEnabled ? null : <OpenButton />, document.body)
        : null
}

export default BulkEditButton
